import config from 'src/config/config';
import { ERequestType } from './enumRequest';

export const payment = {
  createPaymentAddress: (data: any) => {
    return fetch(`${config.apiUrl}/v1/client/address`, {
      method: ERequestType.POST,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  },
};
